import { BigNumber } from '@0x/utils'
// tslint:disable-next-line:custom-no-magic-numbers
export const ONE_SECOND_MS = 1000
// tslint:disable-next-line:custom-no-magic-numbers
export const ONE_MINUTE_MS = ONE_SECOND_MS * 60
// tslint:disable-next-line:custom-no-magic-numbers
export const TEN_MINUTES_MS = ONE_MINUTE_MS * 10
// tslint:disable-next-line:custom-no-magic-numbers
export const UNLIMITED_ALLOWANCE_IN_BASE_UNITS = new BigNumber(2).pow(256).minus(1)
// tslint:disable-next-line:custom-no-magic-numbers
export const NULL_ADDRESS = '0x0000000000000000000000000000000000000000'
export const NULL_BYTES = '0x'
export const ZERO = new BigNumber(0)
export const TX_DEFAULTS = { gas: 600000, gasPrice: 1000000000 }
export const ORDER_STATUS = {
	0: 'Invalid',
	1: 'InvalidMakerAssetAmount',
	2: 'InvalidTakerAssetAmount',
	3: 'Fillable',
	4: 'Expired',
	5: 'FullyFilled',
	6: 'Cancelled'
}
